import { ReactNode } from "react";

// ========== FIELD GROUP ==========
type FieldGroupProps = {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  columns?: 1 | 2;
  className?: string;
};

export function FieldGroup({
  title,
  icon,
  children,
  columns = 1,
  className = "",
}: FieldGroupProps) {
  return (
    <div className={`space-y-4 ${className}`}>
      <h2 className="text-md font-medium flex items-center gap-2">
        {icon}
        {title}
      </h2>
      <div
        className={columns === 2 ? "grid gap-4 md:grid-cols-2" : "space-y-4"}
      >
        {children}
      </div>
    </div>
  );
}
